import React, { Fragment } from 'react'

const About = () => {
    return (
        <Fragment>
            <h1>About This App</h1>
            <p>App to search Github users</p>
            <p>version: 1.0.0</p>
        </Fragment>
    )
}

export default About;